import {
  SURVEY_CHOICE_TYPES,
  SURVEY_QUESTION_TYPES,
  SURVEY_TEXT_TYPES,
} from 'constants/survey'

export function isSurveyAnswerEmpty(question, value) {
  if (SURVEY_CHOICE_TYPES.includes(question?.type)) {
    return !Array.isArray(value) || value.length === 0
  }
  if (SURVEY_TEXT_TYPES.includes(question?.type)) {
    return !String(value || '').trim()
  }
  return value === undefined || value === null || value === ''
}

export function validateSurveyQuestion(question, value, requiredMessage) {
  if (question?.required && isSurveyAnswerEmpty(question, value)) {
    return requiredMessage
  }
  if (
    !isSurveyAnswerEmpty(question, value)
    && [
      SURVEY_QUESTION_TYPES.NUMERIC_SCALE,
      SURVEY_QUESTION_TYPES.STAR_RATING,
    ].includes(question?.type)
  ) {
    const numericValue = Number(value)
    const minimum = Number(question?.minimum ?? 1)
    const maximum = Number(question?.maximum ?? 5)
    if (!Number.isFinite(numericValue) || numericValue < minimum || numericValue > maximum) {
      return `${minimum}–${maximum}`
    }
  }
  return null
}

export function findFirstInvalidSurveyQuestion(questions = [], answers = {}, requiredMessage) {
  return questions.findIndex(question => (
    !!validateSurveyQuestion(question, answers?.[question?.id], requiredMessage)
  ))
}

export function buildSurveyAnswers(questions = [], answers = {}) {
  return questions.reduce((payload, question) => {
    const value = answers?.[question?.id]
    if (isSurveyAnswerEmpty(question, value)) return payload

    if (question?.type === SURVEY_QUESTION_TYPES.SINGLE_CHOICE) {
      payload.push({ questionId: question.id, optionId: value?.[0] })
      return payload
    }
    if (question?.type === SURVEY_QUESTION_TYPES.MULTIPLE_CHOICE) {
      payload.push({ questionId: question.id, optionIds: value })
      return payload
    }
    payload.push({ questionId: question.id, value })
    return payload
  }, [])
}

export function getSurveyRequirementError(response) {
  return response?.error?.details?.code === 'SURVEY_REQUIRED_BEFORE_QUIZ'
    ? {
      courseId: response?.error?.details?.courseId,
      message: response?.error?.message,
    }
    : null
}
